import React from "react";

import {
    getColorFromButton,
    getGlobalColorValue,
} from "@components/OrderTaking/Helpers";

/* `getGlobalColorValue` goes through `window.getComputedStyle`, which forces a
   style recalculation. The cards used to pay that once each, on every render,
   so it scaled with the number of gifts and rewards on screen. The value is the
   same for the whole loyalty screen, so it is read once here and shared. */

function computeContrastColor(): string {
    return getColorFromButton(getGlobalColorValue("--global-color"));
}

const ContrastColorContext = React.createContext<string | null>(null);

export function ContrastColorProvider({
    children,
}: {
    children: React.ReactNode;
}): JSX.Element {
    const contrastColor = React.useMemo(computeContrastColor, []);

    return (
        <ContrastColorContext.Provider value={contrastColor}>
            {children}
        </ContrastColorContext.Provider>
    );
}

export function useContrastColor(): string {
    const contrastColor = React.useContext(ContrastColorContext);

    // rendered outside the loyalty screen: fall back to reading it directly
    return contrastColor ?? computeContrastColor();
}
